/* Luxe Manage Subscription — email lookup, routes to the right dashboard */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function initSection(root) {
    if (!root || root.dataset.luxeMsInit === '1') return;
    root.dataset.luxeMsInit = '1';

    var form = root.querySelector('[data-ms-form]');
    var input = root.querySelector('input[type="email"]');
    var honeypot = root.querySelector('input[name="website"]');
    var submit = root.querySelector('[data-ms-submit]');
    var submitLabel = root.querySelector('[data-ms-submit-label]');
    var spinner = root.querySelector('.luxe-ms__spinner');
    var errorEl = root.querySelector('[data-ms-error]');
    var resultEl = root.querySelector('[data-ms-result]');
    var panels = root.querySelectorAll('[data-panel]');
    var retry = root.querySelector('[data-ms-retry]');

    if (!form || !input) return;

    var endpoint = root.dataset.endpoint;
    var autoRedirect = root.dataset.autoRedirect === 'true';
    var redirectDelay = parseInt(root.dataset.redirectDelay, 10) * 1000 || 0;
    var redirectTimer = null;

    function showError(message) {
      if (!errorEl) return;
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    function clearError() {
      if (errorEl) errorEl.hidden = true;
    }

    function setLoading(isLoading) {
      if (submit) submit.disabled = isLoading;
      if (submitLabel) submitLabel.hidden = isLoading;
      if (spinner) spinner.hidden = !isLoading;
    }

    function reset() {
      if (redirectTimer) clearTimeout(redirectTimer);
      resultEl.hidden = true;
      panels.forEach(function (p) { p.hidden = true; });
      form.hidden = false;
      clearError();
      input.value = '';
      input.focus();
    }

    // Single-provider results move the customer along automatically; the button
    // stays visible so a blocked redirect is never a dead end.
    function scheduleRedirect(panel) {
      if (!autoRedirect) return;
      var link = panel.querySelector('a[href]');
      if (!link) return;

      var notice = root.dataset.redirectNotice;
      if (notice) {
        var note = document.createElement('p');
        note.className = 'luxe-ms__redirect-note';
        note.textContent = notice;
        panel.appendChild(note);
      }

      redirectTimer = setTimeout(function () { window.location.href = link.href; }, redirectDelay);
    }

    function showResult(status) {
      var panel = root.querySelector('[data-panel="' + status + '"]');
      if (!panel) return showError(root.dataset.errorGeneric);

      form.hidden = true;
      resultEl.hidden = false;
      panels.forEach(function (p) { p.hidden = p !== panel; });
      resultEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      if (status === 'kaching' || status === 'checkoutchamp') scheduleRedirect(panel);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      clearError();

      var email = (input.value || '').trim();
      if (!EMAIL_RE.test(email)) {
        showError(root.dataset.errorInvalid);
        input.focus();
        return;
      }

      if (!endpoint) {
        showError(root.dataset.errorGeneric);
        return;
      }

      setLoading(true);

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email, website: honeypot ? honeypot.value : '' })
      })
        .then(function (res) {
          return res.json().then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function (r) {
          setLoading(false);
          if (r.status === 429) return showError(root.dataset.errorRate);
          if (!r.ok || !r.data || !r.data.status) return showError(root.dataset.errorGeneric);
          showResult(r.data.status);
        })
        .catch(function () {
          setLoading(false);
          showError(root.dataset.errorGeneric);
        });
    });

    if (retry) retry.addEventListener('click', reset);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-luxe-ms]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
